/** @jsxImportSource @emotion/react */

import { CSSProperties } from 'react';

import { unmetPasswordRules } from '../../utils/passwordPolicy';
import { fonts } from '../../style/fonts';

/**
 * Renders the password rules that are not yet satisfied.
 *
 * Shared by the pre-auth `ForceNewPassword` screen (`AppWithAuth.tsx`) and the
 * in-app change-password dialog, so the two can never drift apart. Sharing the
 * RENDERER — not just the rules array — is the point: two hand-written lists
 * off one array still drift (and did: the old inline version tested `hasUpper`
 * for the lowercase message, so "no lowercase" showed no message at all while
 * the submit button stayed disabled).
 *
 * Deliberately free of Redux and MUI: it renders inside the pre-auth Amplify
 * shell, which is mounted outside the Redux `<Provider>`.
 */
export default function PasswordRulesList({
  password,
  id,
}: {
  password: string;
  /** Lets a caller wire this up as the field's `aria-describedby`. */
  id?: string;
}) {
  const unmet = unmetPasswordRules(password);

  return (
    <div id={id} style={fonts.text as CSSProperties} aria-live="polite">
      {unmet.map((rule) => (
        <div key={rule.id}>{rule.message}</div>
      ))}
    </div>
  );
}
